class ConsoleWrapper {
  constructor(styles) {
    this.enabled =
      location.hostname === "localhost" || location.hostname === "127.0.0.1";
    this.styles = {
      padding: "6px",
      "background-color": "rgba(255, 218, 0, 0.99)",
      color: "rgb(51, 51, 51)",
      "border-radius": "3px",
      margin: "3px auto",
      ...styles
    };
  }

  style(styles) {
    return Object.entries(styles || this.styles)
      .map(function(style) {
        return style.join(":");
      })
      .join(";");
  }

  log() {
    let args = [...arguments];
    this.enabled && console.log("%c" + args.join(" "), this.style());
  }
}

const Console = new ConsoleWrapper();

export default Console;
